// Aura level calculation utilities

export const LEVELS = [
  { code: 'npc',    key: 'levels.npc',    min: 0,        max: 1000,     color: '#A0A0B0' },
  { code: 'rookie', key: 'levels.rookie', min: 1001,     max: 10000,    color: '#00F0FF' },
  { code: 'farmer', key: 'levels.farmer', min: 10001,    max: 50000,    color: '#00FFA3' },
  { code: 'master', key: 'levels.master', min: 50001,    max: 250000,   color: '#B026FF' },
  { code: 'legend', key: 'levels.legend', min: 250001,   max: 999999,   color: '#FFE800' },
  { code: 'god',    key: 'levels.god',    min: 1000000,  max: null,     color: '#FF2E9F' },
];

export function getLevelForAura(points) {
  const p = Math.max(0, Number(points) || 0);
  for (let i = LEVELS.length - 1; i >= 0; i--) {
    if (p >= LEVELS[i].min) return { ...LEVELS[i], index: i };
  }
  return { ...LEVELS[0], index: 0 };
}

export function getNextLevel(points) {
  const cur = getLevelForAura(points);
  if (cur.index >= LEVELS.length - 1) return null;
  return { ...LEVELS[cur.index + 1], index: cur.index + 1 };
}

export function getLevelProgress(points) {
  const cur = getLevelForAura(points);
  const next = getNextLevel(points);
  if (!next) return { percent: 100, pointsToNext: 0, current: cur, next: null };
  const range = next.min - cur.min;
  const done = Math.max(0, Math.min(range, points - cur.min));
  return {
    percent: Math.round((done / range) * 100),
    pointsToNext: Math.max(0, next.min - points),
    current: cur,
    next,
  };
}

export function formatAura(n) {
  const num = Number(n) || 0;
  return num.toLocaleString('en-US');
}

export function winRate(user) {
  const total = (user?.battles || 0);
  if (!total) return 0;
  return Math.round(((user?.wins || 0) / total) * 100);
}
